import React, { useEffect, useState } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { Skeleton, useMediaQuery, useTheme } from "@mui/material";
import { headingFonts } from "../../../Styles/Styles";
import { useNavigate } from "react-router-dom";

// Register Doughnut chart elements
ChartJS.register(ArcElement, Tooltip, Legend);

const TotalAds = () => {
  const [chartData, setChartData] = useState(null);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/charts/total-ads-stats`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        if (response.status === 401) {
          setError("Unauthorized. Please log in.");
          navigate("/get-started");
          return;
        }

        if (response.status === 403) {
          setError("Access denied.");
          return;
        }

        const data = await response.json();

        setChartData({
          labels: ["All Ads", "Deleted Ads", "Sold Ads"],
          datasets: [
            {
              label: "No of Ads",
              data: [data.totalAds, data.totalDeletedAds, data.totalSoldAds],
              backgroundColor: [
                "rgba(75, 192, 192, 0.6)", // All Ads
                "rgba(255, 99, 132, 0.6)", // Deleted Ads
                "rgba(54, 162, 235, 0.6)", // Sold Ads
              ],
              borderColor: [
                "rgba(75, 192, 192, 1)",
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)",
              ],
              borderWidth: 1,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching stats:", error);
        setError("An error occurred while fetching data.");
      }
    };

    fetchStats();
  }, [navigate]);

  return (
    <div style={{ width: "100%", padding: isMobile ? "10px" : "20px" }}>
      <h4 style={{ ...headingFonts, textAlign: "center" }}>
        Total Ad Statistics
      </h4>

      {error && <p style={{ color: "red", textAlign: "center" }}>{error}</p>}

      {!chartData && !error ? (
        <Skeleton variant="rectangular" width="100%" height={400} />
      ) : (
        <Doughnut
          data={chartData}
          options={{
            responsive: true,
            plugins: {
              legend: {
                position: "bottom",
                align: "center",
                labels: {
                  font: { family: "ClashGrotesk-Medium" },
                  letterSpacing: 1,
                },
              },
            },
          }}
          style={{
            maxHeight: isMobile ? "300px" : "400px",
            margin: "0 auto",
          }}
        />
      )}
    </div>
  );
};

export default TotalAds;
